import {AppContext, AppContextProps} from "@/context/AppContext";
import {useContext} from "react";

function useAppContext():AppContextProps{
  return useContext(AppContext) as AppContextProps;
}
export default useAppContext;